import { render, staticRenderFns } from "./PaymentMethodRegist.vue?vue&type=template&id=2c1b0930&"
import script from "./PaymentMethodRegist.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodRegist.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodRegist.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports